// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-copy {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.comp-copy .copy-text {
  padding: 12px;
  display: flex;
  justify-content: center;
  font-family: Ubuntu-R, sans-serif;
  margin-top: -20px;
}`, "",{"version":3,"sources":["webpack://./src/components/footer/components/footerTaps.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,iCAAA;EACA,iBAAA;AACJ","sourcesContent":[".comp-copy {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .copy-text {\n    padding: 12px;\n    display: flex;\n    justify-content: center;\n    font-family: Ubuntu-R, sans-serif;\n    margin-top: -20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
